import { render, staticRenderFns } from "./MorphFilter.vue?vue&type=template&id=66d3d756&"
import script from "./MorphFilter.vue?vue&type=script&lang=js&"
export * from "./MorphFilter.vue?vue&type=script&lang=js&"
import style0 from "./MorphFilter.vue?vue&type=style&index=0&id=66d3d756&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports